import React from 'react';
import { Container, Box, Typography, Grid, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import TwitterIcon from '@mui/icons-material/Twitter';

const Footer = () => {
  return (
    <Box
      sx={{
        py: 5,
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4} justifyContent="space-between" alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              variant="h5"
              sx={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 900,
                background: 'linear-gradient(135deg, #00F5FF, #FF6B35)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mb: 2,
              }}
            >
              KM-BIZZ
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              © 2025 KM-Bizz. All rights reserved.
              <br />
              Building exceptional digital experiences with 10 years of expertise.
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
              Connect with me
            </Typography>
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                justifyContent: { xs: 'flex-start', md: 'flex-end' },
              }}
            >
              {[
                { icon: <LinkedInIcon />, label: 'LinkedIn' },
                { icon: <GitHubIcon />, label: 'GitHub' },
                { icon: <TwitterIcon />, label: 'Twitter' },
              ].map((social, idx) => (
                <IconButton
                  key={idx}
                  aria-label={social.label}
                  sx={{
                    color: 'text.secondary',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    '&:hover': {
                      color: 'primary.main',
                      borderColor: 'primary.main',
                      background: 'rgba(0, 245, 255, 0.1)',
                    },
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
